export default __webpack_public_path__ + "42f384a09ea4da834d33dcced4d15c0a.png";